import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ComandaDetalharRoutingModule } from './comanda-detalhar-routing.module';
import { ComandaDetalharComponent } from './comanda-detalhar.component';
import { DividerModule } from 'primeng/divider';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { TabViewModule } from 'primeng/tabview';
import { MessagesModule } from 'primeng/messages';
import { FormatPipeModule } from 'src/app/admihair/format-pipe/format-pipe.module';


@NgModule({
  declarations: [
    ComandaDetalharComponent
  ],
  imports: [
    CommonModule,
    ComandaDetalharRoutingModule,
    ButtonModule,
    DividerModule,
    ProgressSpinnerModule,
    TableModule,
    TabViewModule,
    MessagesModule,
    FormatPipeModule

  ]
})
export class ComandaDetalharModule { }
